"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgAvatarCrown = function SvgAvatarCrown(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 19,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.009 12.54s.88-6.342 1.823-9.415l-4.758 3.553L9.832.541 5.589 6.678.832 3.125c.943 3.073 1.822 9.416 1.822 9.416l.405.064a43.18 43.18 0 0 0 13.95-.064z",
    fill: "#FFC700"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgAvatarCrown);
var _default = Memo;
exports["default"] = _default;